// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-height[data-v-99adb6cc] {\n  overflow-y: auto;\n  height: 80vh;\n}\n.edit-dealer-card-footer[data-v-99adb6cc] {\n  border: none;\n  background-color: var(--white);\n}\n.locate-dealer-hardhat[data-v-99adb6cc] {\n  color: var(--carbon-600);\n  font-size: 60px;\n}\n.searchResult[data-v-99adb6cc]:hover {\n  background-color: var(--blue-100);\n}\n.preferred-dealer-button[data-v-99adb6cc] {\n  width: 320px;\n}", ""]);
// Exports
module.exports = exports;
